'use client';

import React, { useState } from 'react';
import ReactImageCarousel, { CommonProps, Modal, ModalGateway } from 'react-images';
import { IFrameVideoLightboxView } from './components/IFrameVideoLightboxView';
import { PlayIcon } from '../../../icons/PlayIcon';
import { LazyImage, LazyImageProps } from '../../components/lazyload/LazyImage';
import { Box, BoxProps } from '../box';
import { Button } from '../button';
import { Flex } from '../Flex';
export type VideoLightboxProps = BoxProps & {
  thumbnail: Pick<LazyImageProps, 'src'>['src'];
  thumbnailSet: Pick<LazyImageProps, 'srcSet'>['srcSet'];
  thumbnailProps?: LazyImageProps;
  text: string;
  src: string;
};
export const VideoLightbox = ({
  thumbnail,
  thumbnailSet,
  thumbnailProps,
  text = 'Watch the video',
  src
}: VideoLightboxProps) => {
  const [isVideoShowing, setIsVideoShowing] = useState(false);
  return <>
      <Box height={['280px', '520px']} width={[1, null, '769px']} py="16px" mx="auto" backgroundRepeat="no-repeat" style={{
      backgroundPositionX: '16px',
      backgroundPositionY: '30px'
    }} data-sentry-element="Box" data-sentry-source-file="VideoLightbox.tsx">
        <Box height={['200px', '440px']} width={1} borderRadius="6px" overflow="hidden" data-sentry-element="Box" data-sentry-source-file="VideoLightbox.tsx">
          <LazyImage srcSet={thumbnailSet} src={thumbnail} width={[1, null, '769px']} height={['200px', '440px']} imageProps={{
          onClick: () => setIsVideoShowing(true),
          width: '100%',
          height: '100%',
          style: {
            objectFit: 'cover'
          }
        }} {...thumbnailProps} data-sentry-element="LazyImage" data-sentry-source-file="VideoLightbox.tsx" />
        </Box>
        <Flex pl={['unset', '36px']} data-sentry-element="Flex" data-sentry-source-file="VideoLightbox.tsx">
          <Button mt={['-36px', '-48px']} onClick={() => setIsVideoShowing(true)} zIndex={99} data-sentry-element="Button" data-sentry-source-file="VideoLightbox.tsx">
            <PlayIcon fontSize={['48px', '96px']} data-sentry-element="PlayIcon" data-sentry-source-file="VideoLightbox.tsx" />
          </Button>
          <Flex height={['20px', '40px']} mx={['unset', '16px']} mt="8px" overflow="hidden" data-sentry-element="Flex" data-sentry-source-file="VideoLightbox.tsx">
            <Button fontFamily="muliBold" fontSize={['16px', '20px']} color="wagGreen" m={0} onClick={() => setIsVideoShowing(true)} data-sentry-element="Button" data-sentry-source-file="VideoLightbox.tsx">
              {text}
            </Button>
          </Flex>
        </Flex>
      </Box>

      {/* @ts-expect-error - Modal error */}
      <ModalGateway data-sentry-element="ModalGateway" data-sentry-source-file="VideoLightbox.tsx">
        {isVideoShowing ? <Modal onClose={() => setIsVideoShowing(false)}>
            <ReactImageCarousel currentIndex={0} components={{
          Footer: null,
          View: IFrameVideoLightboxView as React.ComponentType<CommonProps>
        }} frameProps={{
          autoSize: 'height'
        }} views={[{
          source: src
        }]} />
          </Modal> : null}
      </ModalGateway>
    </>;
};